/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
import { ToolOptions, Wrap, ChangeCursor } from './styles';

import geoConfirm from 'services/utils/confirm';

import toolReducer, { initialToolState } from './services/toolReducer';

import Icon from '@map/components/Icons';
import ButtonTooltip from '@map/components/ToolBar/components/ButtonTooltip';
import featureContextMenu from '@map/services/utils/featureContextMenu';
import 'leaflet';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useReducer é um hook parecido com o useState, ele permite a logica
 * de estado personalizada, para acompanhar varios pedaços de estado
 * que dependem de logia complexa o useReducer é indicado.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useState, useEffect, useReducer, useCallback } from 'react';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useMap } from 'views/MapView/hooks';

const distanceOptions = {
  vertexDistances: {
    enable: true,
    position: 'vertex',
    tooltip: true,
  },
  showBearing: true,
  showMarkerPoints: true,
};

const areaOptions = {
  showTempPolygon: true,
  vertexDistances: {
    enable: false,
    position: 'centered',
    tooltip: true,
  },
  showTotalDistance: false,
  showMarkerPoints: true,
};

/**
 * Função responsável por medir a distancia em linha ou poligono,
 * após escolher a função linha deve-se clicar no primeiro ponto duas vezes
 * para deixar a medida salva no mapa, na função poligono a mesma coisa deve-se
 * clicar no primeiro ponto para deixar salva a figura no mapa.
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado 
 * @returns Transforma o ponteiro do mouse em uma mira de bola onde
 * é possivel fazer as marcações dos pontos para as medidas.
 */
export const Measure = ({ mapContext, isActive, setIsActive }) => {
  const [toolState, toolDispatch] = useReducer(toolReducer, initialToolState);

  // Estados de SUBMENU
  const [anchorToolOptions, setAnchorToolOptions] = useState(null);
  useEffect(() => {
    if (!isActive) {
      setAnchorToolOptions(null);
      toolDispatch({ type: 'selectOrToogleActiveTool', payload: null });
    }
  }, [isActive]);

  // ! Após horas e horas tentando corrigir o bug http://dev.inema.ba.gov.br/AMBIENTAL/GEOBAHIA/projeto/Geobahia/novo-geobahia-publico/issues/889 sem sucesso criei um hack temporário que deve servir armazenando todos os ids das features já adicionadas fora do reducer
  // const tmpFeaturesIds = useRef([]);
  // ! Não funcionou, talvez o recurso mais viável seja reconstruir a ferramenta tomando essa por base, pois as mesmas coisas em Draw funciona, já fuçei tudo!
  // TODO @bug

  // Observando se a ferramenta está ativa ou se tem feature criada
  useEffect(() => {
    if (!isActive && toolState.features.length) {
      toolState.features.forEach((l) => l.remove());
      toolDispatch({ type: 'setFeatures', payload: [] });
      toolDispatch({ type: 'selectFeature', payload: null });
    } else if (isActive && !toolState.features.length) {
      toolDispatch({ type: 'selectFeature', payload: null });
    }
  }, [toolState.features, isActive]);

  const { map } = useMap();

  const contextMenuListener = useCallback(
    (event, payload) => {
      if(event === 'ctxmenu:featureremoved') {
        toolDispatch({
          type: 'deleteFeature',
          payload: payload.featureDeleted._leaflet_id,
        })
        return payload
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toolState.activeTool, toolState.features]
  );

  // Handle de listeners create e drawstart do geoman
  useEffect(() => {
    // Função executada ao finalizar o desenho
    const onCreateFeature = (e) => {
      // Abre menu popup com as ações para a feição
      e.layer.on('contextmenu', (event) => {
        event.originalEvent.preventDefault();
        featureContextMenu({
          selectedLayer: e.layer,
          anchorPosition: {
            mouseX: event.originalEvent.clientX - 2,
            mouseY: event.originalEvent.clientY - 4,
          },
          listener: contextMenuListener,
          features: toolState.features,
          map,
          measurementsOptions:
            toolState.activeTool === 'distance' ? distanceOptions : areaOptions,
          options: {
            chooseUnit: true,
            overlapLayer: false,
            label: toolState.activeTool !== 'area',
            areaPerimeterMeasurements: toolState.activeTool === 'area',
          },
        });
      });

      // Habilita a edição da feição
      e.layer.on('dblclick', (event) => {
        map.doubleClickZoom.disable();
        e.layer.pm.toggleEdit();
        setTimeout(() => map.doubleClickZoom.enable(), 300);
      });

      // Exibe as medidas da feição
      e.layer.showMeasurements(
        toolState.activeTool === 'distance' ? distanceOptions : areaOptions
      );
      toolDispatch({ type: 'selectFeature', payload: e.shape });
      toolDispatch({
        type: 'addFeature',
        payload: e.layer,
      });
      toolDispatch({ type: 'selectOrToogleActiveTool', payload: null });
    };

    // Exibir medidas durante o desenho
    const onVertexAdded = ({ workingLayer }) => {
      if (!workingLayer._measurementLayer) {
        workingLayer.showMeasurements(
          toolState.activeTool === 'distance'
            ? { ...distanceOptions, showMarkerPoints: false }
            : { ...areaOptions, showMarkerPoints: false }
        );
      }

      workingLayer.on('pm:vertexadded', (e) => {
        e.workingLayer.updateMeasurements();
      });
      // Ao mover o mouse
      const updateMeasure = (ee) => {
        workingLayer.updateMeasurements(ee);
      };

      map.on('mousemove', updateMeasure);
      map.on('pm:drawend', () => map.off('mousemove', updateMeasure));
    };

    if (isActive && toolState.activeTool) {
      // Caso a ferramenta esteja selecionada
      map.on('pm:create', onCreateFeature);
      map.on('pm:drawstart', onVertexAdded);
      map.pm.enableDraw(
        toolState.activeTool === 'distance' ? 'Line' : 'Polygon',
        {
          allowSelfIntersection: false,
          snappable: true,
          snapDistance: 20,
          finishOn: 'dblclick',
          cursorMarker: false,
        }
      );
    } else {
      // Caso não, é para desligar a ferramenta de desenho
      map.pm.disableDraw();
      if (toolState.activeTool)
        toolDispatch({ type: 'selectOrToogleActiveTool', payload: null });
    }
    return () => {
      map.off('pm:create', onCreateFeature);
      map.off('pm:drawstart', onVertexAdded);
    };
  }, [toolState.activeTool, toolState, isActive, map, contextMenuListener]);
  
  return (
    <Wrap>
      {toolState.activeTool && toolState.activeTool !== 'Marker' && (
        <ChangeCursor />
      )}
      <ButtonTooltip
        tooltip={Measure.properties.alias}
        description={Measure.properties.description}
        onClick={(e) => {
          setIsActive(!isActive);
          setAnchorToolOptions(anchorToolOptions ? null : e.currentTarget);
        }}
        tooltipDisabled={isActive}
        active={isActive}
      >
        <Icon i="map-toolbar-ruler" />
      </ButtonTooltip>
      <ToolOptions open={isActive} anchorEl={anchorToolOptions}>
        <ButtonTooltip
          tooltip="Medir distância"
          activeWithBgColor
          onClick={() =>
            toolDispatch({
              type: 'selectOrToogleActiveTool',
              payload: 'distance',
            })
          }
          active={toolState.activeTool === 'distance'}
          disabled={![null, 'Line'].includes(toolState.selectedFeature)}
        >
          <Icon i="map-toolbar-line" />
        </ButtonTooltip>
        <ButtonTooltip
          tooltip="Medir Área"
          activeWithBgColor
          onClick={() => {
            toolDispatch({ type: 'selectOrToogleActiveTool', payload: 'area' });
          }}
          active={toolState.activeTool === 'area'}
          disabled={
            ![null, 'Polygon', 'Circle'].includes(toolState.selectedFeature)
          }
        >
          <Icon i="map-toolbar-polygon" />
        </ButtonTooltip>
        {toolState.features.length > 0 && (
          <>
            <hr />
            <ButtonTooltip
              tooltip="Remover todas as geometrias"
              activeWithBgColor
              onClick={() =>
                geoConfirm({
                  message:
                    'A(s) medição(ões) será(ão) apagadas. Deseja continuar? ',
                  callback: (confirmed) => {
                    if (confirmed) {
                      toolDispatch({
                        type: 'deleteAllFeatures',
                        payload: { silent: true },
                      });
                    }
                  },
                })
              }
            >
              <Icon i="map-toolbar-trash" />
            </ButtonTooltip>
          </>
        )}
      </ToolOptions>
    </Wrap>
  );
};

Measure.properties = {
  id: 'CPN-TB-M-MEASURE',
  alias: 'Medidas',
  description:
    'Atribui medidas de distância ou área à objetos do tipo linhas e polígonos.',
};

export default Measure;
